import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class ManualProductionEntryServices {

  createManualProductionEntry = async (payload) => {
    const mpe = await Helpers.post({
      url: Constants.ManualProductionEntry,
      data: payload,
    });
    return mpe;
  }

  updateManualProductionEntryStatus = async (payload) => {
    const mpe = await Helpers.put({
      url: `${Constants.ManualProductionEntry}/status`,
      data: payload,
    });
    return mpe;
  }

  deleteManualProductionEntry = async (payload) => {
    const url = Constants.ManualProductionEntry;
    const mpe = await Helpers.put({ url, data: payload });
    return mpe;
  }

  getManualProductionEntries = async (tenantId, peId, status, page, limit, searchKeyword, departmentId, fromDate, toDate, scheduledStartDate, scheduledEndDate) => {
    let url = `${Constants.ManualProductionEntry}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (peId) url += `production_entry_id=${peId}&`;
    if (status) url += `status=${status}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (scheduledStartDate) url += `scheduled_from_date=${dayjs(scheduledStartDate).format('YYYY-MM-DD')}&`;
    if (scheduledEndDate) url += `scheduled_to_date=${dayjs(scheduledEndDate).format('YYYY-MM-DD')}&`;

    const mpe = await Helpers.get({ url });

    return mpe;
  }

}
export default new ManualProductionEntryServices();
